import React from "react";
import styles from "./skeleton.css";
import WhiteCard from "../../shared/white-card";

const Skeleton = () => {
    return (
        <div className={"row"} styleName={"styles.outer"}>
            <WhiteCard>
                <div styleName={"styles.padding"}>
                    <h4 className="shimmer" styleName={"styles.heading"} />
                    <div className="shimmer" styleName={"styles.link"} />
                    <div className={"col-5 shimmer"} styleName={"styles.twitter"} />
                    <div className={"col-5 shimmer"} styleName={"styles.facebook"} />
                    <p className="shimmer" styleName={"styles.text"} />
                    <div className="shimmer" styleName={"styles.inputBox"} />
                </div>
            </WhiteCard>
        </div>
    );
};

export default Skeleton;
